import * as React from 'react'
import { translateCountryName } from "@ui-seeker/utils"
import { Typography } from '@mui/material';

import {RetailerBlock} from "@components";


export default function retailerColumn() {
    return [{
		name: 'seller', label: 'Seller',
		options: {
			display: 'excluded',
		}
	},{
        name: 'seller', label: 'Seller',
        options: {
			headerAlign: 'left',
            filter: false,
            customBodyRowRenderLite: (value) => <Typography variant='body2' sx={{ fontSize: '0.8rem'}}>{value}</Typography>
        }
    }]
}